module.exports = __webpack_public_path__ + "img/6.4d95c4de.jpg";